// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-consultation-bc {
  padding: 2rem;
}

.consultation-header h2 {
  color: #2c3948;
  font-size: 2.4rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.status-info {
  font-weight: 500;
  border-left: 4px solid currentColor;
}

.pending-rang {
  text-align: center;
  padding: 4rem 2rem;
  color: #6b7280;
  font-size: 1.6rem;
}

.financial-options {
  margin-bottom: 2rem;
}

.info-text {
  color: #6b7280;
  font-size: 1.4rem;
  margin-top: 1rem;
  font-style: italic;
}

/* Styles pour le tableau d'articles */
.articles-table-container {
  /* margin-top: 2rem;
  padding: 2rem;
  background-color: #F9FAFB;
  border-radius: 12px;
  border: 1px solid #E5E7EB; */
}

.articles-table-container h4 {
  color: #2c3948;
  font-size: 1.8rem;
  font-weight: 600;
}

.articles-table-wrapper {
  overflow-x: auto;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  margin-bottom: 2rem;
}

.articles-table-wrapper .add-article-button {
  margin: 1rem;
}

.articles-table-footer {
  padding: 2rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
}

.footer-actions {
  display: flex;
  gap: 1rem;
}

.footer-summary {
  text-align: right;
}

.footer-summary h4 {
  margin: 0 0 0.5rem 0;
  color: #2c3948;
  font-size: 1.4rem;
}

.total-section p {
  margin: 0;
  font-weight: 700;
  font-size: 1.8rem;
}

/* Styles spécifiques par colonne - MISE À JOUR */
.article-number {
  text-align: center;
  color: #2c3948;
  width: 8%;
  font-size: 1.3rem;
}

.article-description {
  width: 50%; /* Encore plus large - 4 fois plus large qu'avant */
  padding-right: 2rem;
}

.article-name {
  color: #2c3948;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
}

.article-code {
  color: #6b7280;
  font-size: 1.2rem;
  font-style: italic;
  line-height: 1.3;
}

.article-unit {
  text-align: center;
  width: 8%;
}

.article-quantity {
  text-align: center;
  color: #2c3948;
  font-weight: 600;
  width: 6%;
}

.article-price {
  text-align: right !important; /* Force l'alignement à droite */
  color: #2c3948;
  font-weight: 500;
  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */
}

.article-total {
  text-align: right !important; /* Force l'alignement à droite */
  font-weight: 700;
  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */
}

.price-cell {
  text-align: right !important; /* Force l'alignement à droite */
  color: #2c3948;
  font-weight: 500;
  padding-right: 1rem;
}

.total-cell {
  text-align: right !important; /* Force l'alignement à droite */
  font-weight: 700;
  color: #f97316;
  padding-right: 1rem;
}

.article-actions {
  text-align: center;
  width: 8%; /* Plus large pour correspondre au wireframe */
  position: relative;
}

/* Styles pour le total */
.total-row {
  background-color: #f8f9fa !important;
  border-top: 3px solid #f97316 !important;
  font-weight: 600;
}

.total-row:hover {
  background-color: #f8f9fa !important;
}

.total-row td {
  border-bottom: none !important;
  padding: 2rem 1rem !important;
}

.total-label {
  text-align: right;
  color: #2c3948;
  font-size: 1.6rem;
  font-weight: 700;
}

.total-row .article-total {
  color: #f97316;
  font-size: 1.8rem;
  font-weight: 700;
}

.financial-choice {
  text-align: center;
  padding: 3rem 2rem;
  border: 2px dashed #e5e7eb;
  border-radius: 0.8rem;
  background-color: #f8f9fa;
}

.financial-choice h4 {
  color: #2c3948;
  font-size: 1.8rem;
  margin-bottom: 2rem;
}

.choice-buttons {
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.choice-buttons .button {
  min-width: 250px;
}

.financial-choice .info-text {
  color: #6b7280;
  font-size: 1.4rem;
  line-height: 1.5;
  max-width: 600px;
  margin: 0 auto;
}

.catalogue-mode {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 0.8rem;
  border-left: 4px solid #f97316;
}

.prestataire-mode {
  background-color: rgba(218, 112, 39, 0.15);
  padding: 2rem;
  border-radius: 0.8rem;
  border-left: 4px solid #f97316;
}

.prestataire-mode .info-message h4 {
  color: #1e40af;
  font-size: 1.6rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.prestataire-mode .info-message p {
  color: #1e3a8a;
  font-size: 1.4rem;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.financial-options {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.add-more-articles-btn {
  width: 100%;
  padding: 1rem;
  background: none;
  border: 2px dashed #e5e7eb;
  border-radius: 0.4rem;
  color: #6b7280;
  cursor: pointer;
  font-size: 1.4rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.add-more-articles-btn:hover {
  border-color: #f97316;
  color: #f97316;
  background-color: rgba(218, 112, 39, 0.05);
}

/* Ajoutez ces styles dans votre fichier ConsultationBC.css */
.demande-envoyee-message {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background-color: #f8f9fa;
  border-left: 4px solid #f97316;
  border-radius: 8px;
  margin: 16px 0;
}

.info-icon {
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 4px;
}

.message-content h4 {
  margin: 0 0 8px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.message-content p {
  margin: 0 0 12px 0;
  color: #6c757d;
  line-height: 1.5;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6c757d;
  font-style: italic;
}

.status-dot {
  width: 8px;
  height: 8px;
  background-color: #ffc107;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.acheteur-no-rights-message {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin: 1rem 0;
  text-align: center;
}

.acheteur-no-rights-message p {
  margin: 0;
  color: #856404;
  font-weight: 500;
  font-size: 1rem;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.changer-de-mode {
  margin-bottom: 2rem;
}

/* Styles pour les prestataires remplissant les articles transférés */
.prestataire-fill-articles {
  padding: 0; /* Pas de padding pour réutiliser les classes existantes */
}

.prestataire-instructions {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: rgba(218, 112, 39, 0.15);
  border-radius: 8px;
  border-left: 4px solid #f97316;
}

.prestataire-instructions h4 {
  margin-bottom: 0.5rem;
  font-size: 1.6rem;
}

.prestataire-instructions p {
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.5;
}

.prestataire-no-access {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-style: italic;
}

/* S'assurer que les classes existantes fonctionnent pour les prestataires */
.prestataire-fill-articles .articles-table-container,
.prestataire-fill-articles .articles-table-wrapper,
.prestataire-fill-articles .add-article-button,
.prestataire-fill-articles .articles-actions,
.prestataire-fill-articles .total-section,
.prestataire-fill-articles .financial-choice,
.prestataire-fill-articles .choice-buttons {
  /* Hériter de tous les styles existants */
}

.action-buttons-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
}

/* Conteneur horizontal pour les boutons d'action */
.action-buttons-row {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/* Conteneur pour le bouton de notification et le message */
.notification-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

/* Liste des notifications envoyées (pour plusieurs notifications) */
.notifications-sent-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

/* Message indiquant qu'une notification a déjà été envoyée (sous le bouton) */
.notification-sent-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #10b981;
  font-size: 1.2rem;
  font-weight: 500;
}

.notification-sent-info .notification-sent-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  background-color: #10b981;
  color: white;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: bold;
  flex-shrink: 0;
}

/* Message indiquant qu'une notification a déjà été envoyée (ancien style - conservé pour compatibilité) */
.notification-sent-message {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.5rem;
  background-color: #d1fae5;
  border: 1px solid #10b981;
  border-radius: 8px;
  color: #065f46;
  font-size: 1.4rem;
  font-weight: 500;
}

.notification-sent-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background-color: #10b981;
  color: white;
  border-radius: 50%;
  font-size: 1.2rem;
  font-weight: bold;
}

/* Apercu du catalogue rendu par ModalArticles en \`inline\` (et non par une copie de ses lignes).
   Reprend la mecanique de l'ancien CataloguePreview : dezoom, bordure orange au survol, et surtout
   neutralisation des interactions internes -> c'est le CONTENEUR qui porte le clic (ouvrir la vraie
   modale), pas les controles de la ligne. */
/* Les trois voies de composition, offertes ensemble au-dessus de l'apercu. */
.catalogue-choix-info {
  margin-bottom: 12px;
}

/* Les trois voies sur UNE ligne, a largeur EGALE : \`nowrap\` interdit l'enroulement de la rangee, et
   \`flex: 1 1 0\` sur chaque enfant leur donne le meme tiers — la base est 0, donc la longueur des
   libelles ne vote pas dans le partage (avec \`auto\`, le plus bavard aurait rafle la place).
   \`align-items: stretch\` (et non \`center\`) donne a l'input la hauteur EXACTE des boutons voisins, sans
   figer de hauteur en dur qui divergerait au premier repadding du Button. Le \`align-self: stretch\` du
   Button, ailleurs un piege, joue ici en notre faveur. */
.catalogue-choix {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 10px;
  /* 2px de garde INTERIEURE : l'ombre de focus du 3e choix (2px de spread) se dessine DANS ce padding
     au lieu de deborder du bord de la rangee. Le 3e choix est le dernier enfant, colle a droite : son
     ombre tombait hors de la boite, ou quelque chose la rognait. Le padding la ramene dedans — il n'y
     a plus rien a rogner, quel que soit l'ancetre responsable.
     Pas de marge negative pour compenser : elle rendrait l'ombre au bord d'origine, donc au rognage.
     Les 2px de decalage sur les trois choix ne se voient pas ; une ombre coupee, si. */
  padding: 2px;
  margin-bottom: 10px;
}

/* Un tiers chacun. Les libelles s'enroulent DANS leur bouton plutot que de l'elargir : c'est la
   RANGEE qui tient sur une ligne, pas chaque intitule. */
.catalogue-choix > .button,
.catalogue-choix > .catalogue-choix-code {
  flex: 1 1;
  min-width: 0;
}

.catalogue-choix > .button {
  white-space: normal;
  text-align: center;
  padding-left: 12px;
  padding-right: 12px;
}

/* Choix RETENU (et non actionne) : le gris de selection deja utilise dans le catalogue pour un article
   retenu (\`.article-row.article-added\` : fond #f8f9fa, survol #e9ecef). Une bordure plus franche
   (#595959, le gris des titres) le distingue des voies non retenues, sans liseré orange.
   Ni orange plein (reserve a la voie du code, qui porte une action), ni le gris #6b7280 de
   l'annulation/suppression, qui dirait "action destructrice" au lieu de "choix retenu".
   Specificite (0,3,0) : bat \`.button.secondary\` (0,2,0). Le survol, lui, est monte a (0,4,0) — a
   (0,3,0) il aurait EGALE \`.button.secondary:hover\` et le gagnant aurait dependu de l'ordre d'import
   des feuilles, ce qui ne se decrete pas depuis ici. */
.catalogue-choix > .button.catalogue-choix-btn--retenu {
  background-color: #f8f9fa;
  border: 1px solid #595959;
  color: #374151;
}

.catalogue-choix > .button.catalogue-choix-btn--retenu:hover {
  background-color: #e9ecef;
}

/* Input + bouton soudes : un seul objet, sans gouttiere entre les deux. */
.catalogue-choix-code {
  display: flex;
  align-items: stretch;
  /* Porte le rayon de l'objet entier : c'est lui que l'ombre de focus doit epouser. */
  border-radius: 8px;
}

/* Focus : l'ombre ceint l'OBJET (input + bouton), pas l'input seul. Posee sur l'input, elle dessinait
   un anneau qui traversait la soudure et coupait en deux ce qui doit se lire comme une seule chose.
   \`:focus-within\` et non \`:focus\` : c'est le groupe qui reagit au focus de son enfant. */
.catalogue-choix-code:focus-within {
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.25);
}

.catalogue-choix-code-input {
  /* Calee sur le PLACEHOLDER (~44 caracteres a 14px), pas sur la valeur : 8 caracteres tiendraient
     dans 10ch, mais c'est l'intitule qui enonce la voie et il doit se lire en entier.
     \`min-width: 0\` pour que l'input puisse ceder si la fenetre serre — sans lui, un enfant flex refuse
     de passer sous sa largeur intrinseque et ferait deborder la rangee, que \`nowrap\` empeche justement
     d'enrouler. */
  flex: 1 1 350px;
  min-width: 0;
  /* Padding vertical du Button (9px) pour que la soudure soit invisible ; horizontal reduit a 10px —
     28px de gouttiere, c'est autant de moins pour l'intitule, qui est ce qu'on cherche a faire tenir. */
  padding: 9px 10px;
  font-size: 14px;
  color: #374151;
  /* Bordure ORANGE, et non grise : cette voie est un seul objet oriente action, dont l'input est la
     moitie gauche. Une bordure grise a gauche et un bouton orange a droite feraient deux objets.
     Au repos, l'orange est FANE : le bouton est alors desactive (code incomplet) et le Button se fane
     par \`opacity: .5\`. #fcb98a = #f97316 a 50% sur blanc — la teinte que l'opacite produit. C'est un
     calcul, pas un choix : une autre valeur ferait dépareiller les deux moities. */
  border: 1px solid #fcb98a;
  border-right: none;
  border-radius: 8px 0 0 8px;
}

/* Code complet : l'objet entier passe a l'orange plein, en meme temps que le bouton redevient actif. */
.catalogue-choix-code--pret .catalogue-choix-code-input {
  border-color: #f97316;
}

/* Le placeholder SEUL est reduit — pas l'input : son \`font-size\` pilote aussi le code saisi, qu'on
   veut lisible a 14px. Ici c'est un intitule long dans une boite etroite, il peut se contenter de
   moins pour tenir en entier plutot que de finir en ellipse. */
.catalogue-choix-code-input::placeholder {
  font-size: 12px;
}

/* La valeur, elle, est un code : meme traitement que partout ailleurs dans la feature. */
.catalogue-choix-code-input:not(:placeholder-shown) {
  font-family: 'Courier New', Courier, monospace;
  font-weight: 600;
  letter-spacing: 0.06em;
}

/* Le focus est signale par l'ombre du GROUPE (cf. \`.catalogue-choix-code:focus-within\`), pas ici : la
   bordure, elle, porte l'etat du bouton (fane/plein).
   \`border-color\` est REDECLARE, pas oublie : \`App.css\` porte un \`input:focus { border-color: #f97316 }\`
   GLOBAL. Ne pas le contredire, c'est le laisser rallumer l'orange plein au focus alors que le bouton
   est encore fane. Ma regle pese (0,2,0) contre (0,1,1) — elle gagne des lors qu'elle declare la
   couleur. */
.catalogue-choix-code-input:focus {
  outline: none;
  border-color: #fcb98a;
}

/* Code complet + focus : l'orange plein, comme le bouton redevenu actif. (0,3,0) > (0,2,0). */
.catalogue-choix-code--pret .catalogue-choix-code-input:focus {
  border-color: #f97316;
}

.catalogue-choix-code-input:disabled {
  background: #f8f9fa;
  cursor: not-allowed;
}

/* Cote jointure : angles droits, pour que les deux ne fassent qu'un.
   Le bouton ne grandit pas et ne s'enroule pas : son libelle est court ("Charger"), donc il tient sur
   une ligne et laisse tout le reste du tiers a l'input, qui prime — c'est lui qu'on remplit. */
.catalogue-choix-code > button {
  /* \`0 1 auto\` et non \`0 0 auto\` : il garde la largeur de son libelle mais CEDE plutot que de deborder
     du groupe. Un enfant qui deborde depasse la boite sur laquelle l'ombre est dessinee — elle se
     retrouve alors derriere lui, ce qui la fait paraitre coupee a droite. */
  flex: 0 1 auto;
  min-width: 0;
  border-radius: 0 8px 8px 0;
  white-space: nowrap;
  padding-left: 14px;
  padding-right: 14px;
}

/* Le bouton porte le MEME ourlet orange que l'input sur ses bords exterieurs : \`.button.primary\` pose
   \`border: none\`, ce qui laissait l'objet sans contour a droite et desalignait les deux moities d'1px
   en hauteur (l'input, lui, a ses bordures haute et basse).
   Selecteur double-classe VOLONTAIRE : \`.button.primary\` pese (0,2,0) et battrait un
   \`.catalogue-choix-code > button\` a (0,1,1). Pas de \`!important\` — la specificite suffit.
   \`border-left: none\` : c'est la soudure, l'input y pose deja la sienne. */
.catalogue-choix-code > .button.primary {
  border: 1px solid #f97316;
  border-left: none;
}

.catalogue-choix-code > .button.primary:hover {
  border-color: #ea580c;
}


/* Choix 2 retenu : ce message prend la place de l'apercu du catalogue. Meme emprise verticale que la
   preview qu'il remplace, pour que la page ne saute pas quand l'acheteur change d'avis.

   Rendu calque sur l'encadre du CODE dans le devis PDF (ChiffragePDF, \`codeSection\` : bordure 2px
   #f97316, fond #FFF7ED, radius 8) : ce message occupe la meme place que le chiffrage a venir, il
   doit se lire comme lui et non comme une note grise parmi d'autres.

   Div AUTONOME, plus un composant Banner : ce n'est pas un message d'etat parmi d'autres mais le
   contenu meme de la section, la ou s'affiche normalement le catalogue. Aucune dependance a
   Banner.css — donc pas de surcharge de specificite a gagner, ni d'icone grise a neutraliser. */
.catalogue-attente-titulaire {
  margin-bottom: 12px;
  border: 2px solid #f97316;
  border-radius: 8px;
  background: #fff7ed;
  color: #c2410c;
  /* Un cran au-dessus des 1.4rem courants : "un peu plus gros", pas un titre. */
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.5;
  padding: 1.15rem 1.55rem;
  text-align: center;
}

.catalogue-preview-inline {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  /* \`zoom\` reflow proprement, sans l'espace mort d'un transform: scale. */
  zoom: 0.8;
}

.catalogue-preview-inline:hover,
.catalogue-preview-inline:focus-visible {
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
  outline: none;
}

/* Le catalogue est deja encadre par le conteneur : pas de double bordure. */
.catalogue-preview-inline .modal-articles {
  border: none;
}

/* AUCUN element interieur ne capte le clic : il doit remonter au conteneur, qui ouvre la vraie
   modale. On neutralise donc tout le sous-arbre (recherche, Details, controles de quantite...) plutot
   que d'enumerer les elements un par un et d'en oublier. */
.catalogue-preview-inline .modal-articles * {
  pointer-events: none;
}

/* Curseur pointer sur TOUT l'apercu : il est cliquable de bout en bout (l'input de recherche
   afficherait sinon un curseur texte, les boutons leur propre curseur). */
.catalogue-preview-inline,
.catalogue-preview-inline * {
  cursor: pointer;
}

/* Titre reduit : l'apercu est une miniature, pas la modale. */
.catalogue-preview-inline .modal-articles-header h2 {
  font-size: 1.6rem;
}

/* Mention réglementaire du « Descriptif procédural » (BC acheteur ET prestataire) : l'espace SOUS la
   bannière doit égaler celui AU-DESSUS.

   Au-dessus = padding-top de la section. ATTENTION : ce n'est PAS le 1.5rem de SectionPliable.css,
   surchargé dans les deux vues BC par \`.consultation-bc .section-pliable-content { padding: 4rem }\`
   (spécificité 0,2,0 contre 0,1,0). En dessous = \`margin-bottom\` de \`.ui-banner\`, qui vaut 1.5rem
   par défaut — d'où une asymétrie visible de 4rem contre 1.5rem.

   Sélecteur ancré sur \`.consultation-bc\` : la valeur 4rem ne vaut QUE dans ce contexte, la reprendre
   hors de lui recréerait l'écart en sens inverse. Classe dédiée pour ne toucher aucune autre bannière. */
.consultation-bc .ui-banner.bc-mention-procedural {
  margin-bottom: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/OperationConsultationBC/OperationConsultationBC.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;;;;8BAI4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU,EAAE,mDAAmD;EAC/D,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,cAAc;EACd,gBAAgB;EAChB,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,gBAAgB;EAChB,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B,EAAE,gCAAgC;EAC9D,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,8CAA8C;EACzD,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0CAA0C;AAC5C;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,UAAU,EAAE,0DAA0D;AACxE;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;;;;;;;EAOE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0GAA0G;AAC1G;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;4CAG4C;AAC5C,6EAA6E;AAC7E;EACE,mBAAmB;AACrB;;AAEA;;;;;yDAKyD;AACzD;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT;;;;;uFAKqF;EACrF,YAAY;EACZ,mBAAmB;AACrB;;AAEA;yDACyD;AACzD;;EAEE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;uDAOuD;AACvD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,oBAAoB;EACpB,oFAAoF;EACpF,kBAAkB;AACpB;;AAEA;;yFAEyF;AACzF;EACE,8CAA8C;AAChD;;AAEA;EACE;;;;kBAIgB;EAChB,eAAe;EACf,YAAY;EACZ;wGACsG;EACtG,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd;;;;mFAIiF;EACjF,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,uGAAuG;AACvG;EACE,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;AACjB;;AAEA,yFAAyF;AACzF;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;aAKa;AACb;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,8FAA8F;AAC9F;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;+FAE+F;AAC/F;EACE;;4EAE0E;EAC1E,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;2EAK2E;AAC3E;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;;;;;;;;;gGASgG;AAChG;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8EAA8E;EAC9E,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;EAC1D,wEAAwE;EACxE,SAAS;AACX;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA,4EAA4E;AAC5E;EACE,YAAY;AACd;;AAEA;;2DAE2D;AAC3D;EACE,oBAAoB;AACtB;;AAEA;0EAC0E;AAC1E;;EAEE,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;yGASyG;AACzG;EACE,mBAAmB;AACrB","sourcesContent":[".tab-consultation-bc {\n  padding: 2rem;\n}\n\n.consultation-header h2 {\n  color: #2c3948;\n  font-size: 2.4rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.status-info {\n  font-weight: 500;\n  border-left: 4px solid currentColor;\n}\n\n.pending-rang {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #6b7280;\n  font-size: 1.6rem;\n}\n\n.financial-options {\n  margin-bottom: 2rem;\n}\n\n.info-text {\n  color: #6b7280;\n  font-size: 1.4rem;\n  margin-top: 1rem;\n  font-style: italic;\n}\n\n/* Styles pour le tableau d'articles */\n.articles-table-container {\n  /* margin-top: 2rem;\n  padding: 2rem;\n  background-color: #F9FAFB;\n  border-radius: 12px;\n  border: 1px solid #E5E7EB; */\n}\n\n.articles-table-container h4 {\n  color: #2c3948;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.articles-table-wrapper {\n  overflow-x: auto;\n  background-color: white;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  margin-bottom: 2rem;\n}\n\n.articles-table-wrapper .add-article-button {\n  margin: 1rem;\n}\n\n.articles-table-footer {\n  padding: 2rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1.5rem;\n}\n\n.footer-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.footer-summary {\n  text-align: right;\n}\n\n.footer-summary h4 {\n  margin: 0 0 0.5rem 0;\n  color: #2c3948;\n  font-size: 1.4rem;\n}\n\n.total-section p {\n  margin: 0;\n  font-weight: 700;\n  font-size: 1.8rem;\n}\n\n/* Styles spécifiques par colonne - MISE À JOUR */\n.article-number {\n  text-align: center;\n  color: #2c3948;\n  width: 8%;\n  font-size: 1.3rem;\n}\n\n.article-description {\n  width: 50%; /* Encore plus large - 4 fois plus large qu'avant */\n  padding-right: 2rem;\n}\n\n.article-name {\n  color: #2c3948;\n  font-weight: 600;\n  line-height: 1.4;\n  margin-bottom: 0.8rem;\n  font-size: 1.4rem;\n}\n\n.article-code {\n  color: #6b7280;\n  font-size: 1.2rem;\n  font-style: italic;\n  line-height: 1.3;\n}\n\n.article-unit {\n  text-align: center;\n  width: 8%;\n}\n\n.article-quantity {\n  text-align: center;\n  color: #2c3948;\n  font-weight: 600;\n  width: 6%;\n}\n\n.article-price {\n  text-align: right !important; /* Force l'alignement à droite */\n  color: #2c3948;\n  font-weight: 500;\n  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */\n}\n\n.article-total {\n  text-align: right !important; /* Force l'alignement à droite */\n  font-weight: 700;\n  padding-right: 1rem; /* Ajouter du padding à droite pour l'espacement */\n}\n\n.price-cell {\n  text-align: right !important; /* Force l'alignement à droite */\n  color: #2c3948;\n  font-weight: 500;\n  padding-right: 1rem;\n}\n\n.total-cell {\n  text-align: right !important; /* Force l'alignement à droite */\n  font-weight: 700;\n  color: #f97316;\n  padding-right: 1rem;\n}\n\n.article-actions {\n  text-align: center;\n  width: 8%; /* Plus large pour correspondre au wireframe */\n  position: relative;\n}\n\n/* Styles pour le total */\n.total-row {\n  background-color: #f8f9fa !important;\n  border-top: 3px solid #f97316 !important;\n  font-weight: 600;\n}\n\n.total-row:hover {\n  background-color: #f8f9fa !important;\n}\n\n.total-row td {\n  border-bottom: none !important;\n  padding: 2rem 1rem !important;\n}\n\n.total-label {\n  text-align: right;\n  color: #2c3948;\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n.total-row .article-total {\n  color: #f97316;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.financial-choice {\n  text-align: center;\n  padding: 3rem 2rem;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.8rem;\n  background-color: #f8f9fa;\n}\n\n.financial-choice h4 {\n  color: #2c3948;\n  font-size: 1.8rem;\n  margin-bottom: 2rem;\n}\n\n.choice-buttons {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.choice-buttons .button {\n  min-width: 250px;\n}\n\n.financial-choice .info-text {\n  color: #6b7280;\n  font-size: 1.4rem;\n  line-height: 1.5;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.catalogue-mode {\n  background-color: #f8f9fa;\n  padding: 2rem;\n  border-radius: 0.8rem;\n  border-left: 4px solid #f97316;\n}\n\n.prestataire-mode {\n  background-color: rgba(218, 112, 39, 0.15);\n  padding: 2rem;\n  border-radius: 0.8rem;\n  border-left: 4px solid #f97316;\n}\n\n.prestataire-mode .info-message h4 {\n  color: #1e40af;\n  font-size: 1.6rem;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.prestataire-mode .info-message p {\n  color: #1e3a8a;\n  font-size: 1.4rem;\n  margin-bottom: 2rem;\n  line-height: 1.5;\n}\n\n.financial-options {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.add-more-articles-btn {\n  width: 100%;\n  padding: 1rem;\n  background: none;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.4rem;\n  color: #6b7280;\n  cursor: pointer;\n  font-size: 1.4rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.add-more-articles-btn:hover {\n  border-color: #f97316;\n  color: #f97316;\n  background-color: rgba(218, 112, 39, 0.05);\n}\n\n/* Ajoutez ces styles dans votre fichier ConsultationBC.css */\n.demande-envoyee-message {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-left: 4px solid #f97316;\n  border-radius: 8px;\n  margin: 16px 0;\n}\n\n.info-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.message-content h4 {\n  margin: 0 0 8px 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.message-content p {\n  margin: 0 0 12px 0;\n  color: #6c757d;\n  line-height: 1.5;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #ffc107;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.acheteur-no-rights-message {\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 8px;\n  padding: 1rem 1.5rem;\n  margin: 1rem 0;\n  text-align: center;\n}\n\n.acheteur-no-rights-message p {\n  margin: 0;\n  color: #856404;\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.changer-de-mode {\n  margin-bottom: 2rem;\n}\n\n/* Styles pour les prestataires remplissant les articles transférés */\n.prestataire-fill-articles {\n  padding: 0; /* Pas de padding pour réutiliser les classes existantes */\n}\n\n.prestataire-instructions {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background-color: rgba(218, 112, 39, 0.15);\n  border-radius: 8px;\n  border-left: 4px solid #f97316;\n}\n\n.prestataire-instructions h4 {\n  margin-bottom: 0.5rem;\n  font-size: 1.6rem;\n}\n\n.prestataire-instructions p {\n  margin: 0;\n  font-size: 1.4rem;\n  line-height: 1.5;\n}\n\n.prestataire-no-access {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* S'assurer que les classes existantes fonctionnent pour les prestataires */\n.prestataire-fill-articles .articles-table-container,\n.prestataire-fill-articles .articles-table-wrapper,\n.prestataire-fill-articles .add-article-button,\n.prestataire-fill-articles .articles-actions,\n.prestataire-fill-articles .total-section,\n.prestataire-fill-articles .financial-choice,\n.prestataire-fill-articles .choice-buttons {\n  /* Hériter de tous les styles existants */\n}\n\n.action-buttons-group {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n}\n\n/* Conteneur horizontal pour les boutons d'action */\n.action-buttons-row {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n/* Conteneur pour le bouton de notification et le message */\n.notification-button-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Liste des notifications envoyées (pour plusieurs notifications) */\n.notifications-sent-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n/* Message indiquant qu'une notification a déjà été envoyée (sous le bouton) */\n.notification-sent-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #10b981;\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n.notification-sent-info .notification-sent-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  background-color: #10b981;\n  color: white;\n  border-radius: 50%;\n  font-size: 1rem;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n/* Message indiquant qu'une notification a déjà été envoyée (ancien style - conservé pour compatibilité) */\n.notification-sent-message {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 1rem 1.5rem;\n  background-color: #d1fae5;\n  border: 1px solid #10b981;\n  border-radius: 8px;\n  color: #065f46;\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.notification-sent-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  background-color: #10b981;\n  color: white;\n  border-radius: 50%;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n/* Apercu du catalogue rendu par ModalArticles en `inline` (et non par une copie de ses lignes).\n   Reprend la mecanique de l'ancien CataloguePreview : dezoom, bordure orange au survol, et surtout\n   neutralisation des interactions internes -> c'est le CONTENEUR qui porte le clic (ouvrir la vraie\n   modale), pas les controles de la ligne. */\n/* Les trois voies de composition, offertes ensemble au-dessus de l'apercu. */\n.catalogue-choix-info {\n  margin-bottom: 12px;\n}\n\n/* Les trois voies sur UNE ligne, a largeur EGALE : `nowrap` interdit l'enroulement de la rangee, et\n   `flex: 1 1 0` sur chaque enfant leur donne le meme tiers — la base est 0, donc la longueur des\n   libelles ne vote pas dans le partage (avec `auto`, le plus bavard aurait rafle la place).\n   `align-items: stretch` (et non `center`) donne a l'input la hauteur EXACTE des boutons voisins, sans\n   figer de hauteur en dur qui divergerait au premier repadding du Button. Le `align-self: stretch` du\n   Button, ailleurs un piege, joue ici en notre faveur. */\n.catalogue-choix {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  gap: 10px;\n  /* 2px de garde INTERIEURE : l'ombre de focus du 3e choix (2px de spread) se dessine DANS ce padding\n     au lieu de deborder du bord de la rangee. Le 3e choix est le dernier enfant, colle a droite : son\n     ombre tombait hors de la boite, ou quelque chose la rognait. Le padding la ramene dedans — il n'y\n     a plus rien a rogner, quel que soit l'ancetre responsable.\n     Pas de marge negative pour compenser : elle rendrait l'ombre au bord d'origine, donc au rognage.\n     Les 2px de decalage sur les trois choix ne se voient pas ; une ombre coupee, si. */\n  padding: 2px;\n  margin-bottom: 10px;\n}\n\n/* Un tiers chacun. Les libelles s'enroulent DANS leur bouton plutot que de l'elargir : c'est la\n   RANGEE qui tient sur une ligne, pas chaque intitule. */\n.catalogue-choix > .button,\n.catalogue-choix > .catalogue-choix-code {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.catalogue-choix > .button {\n  white-space: normal;\n  text-align: center;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n/* Choix RETENU (et non actionne) : le gris de selection deja utilise dans le catalogue pour un article\n   retenu (`.article-row.article-added` : fond #f8f9fa, survol #e9ecef). Une bordure plus franche\n   (#595959, le gris des titres) le distingue des voies non retenues, sans liseré orange.\n   Ni orange plein (reserve a la voie du code, qui porte une action), ni le gris #6b7280 de\n   l'annulation/suppression, qui dirait \"action destructrice\" au lieu de \"choix retenu\".\n   Specificite (0,3,0) : bat `.button.secondary` (0,2,0). Le survol, lui, est monte a (0,4,0) — a\n   (0,3,0) il aurait EGALE `.button.secondary:hover` et le gagnant aurait dependu de l'ordre d'import\n   des feuilles, ce qui ne se decrete pas depuis ici. */\n.catalogue-choix > .button.catalogue-choix-btn--retenu {\n  background-color: #f8f9fa;\n  border: 1px solid #595959;\n  color: #374151;\n}\n\n.catalogue-choix > .button.catalogue-choix-btn--retenu:hover {\n  background-color: #e9ecef;\n}\n\n/* Input + bouton soudes : un seul objet, sans gouttiere entre les deux. */\n.catalogue-choix-code {\n  display: flex;\n  align-items: stretch;\n  /* Porte le rayon de l'objet entier : c'est lui que l'ombre de focus doit epouser. */\n  border-radius: 8px;\n}\n\n/* Focus : l'ombre ceint l'OBJET (input + bouton), pas l'input seul. Posee sur l'input, elle dessinait\n   un anneau qui traversait la soudure et coupait en deux ce qui doit se lire comme une seule chose.\n   `:focus-within` et non `:focus` : c'est le groupe qui reagit au focus de son enfant. */\n.catalogue-choix-code:focus-within {\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.25);\n}\n\n.catalogue-choix-code-input {\n  /* Calee sur le PLACEHOLDER (~44 caracteres a 14px), pas sur la valeur : 8 caracteres tiendraient\n     dans 10ch, mais c'est l'intitule qui enonce la voie et il doit se lire en entier.\n     `min-width: 0` pour que l'input puisse ceder si la fenetre serre — sans lui, un enfant flex refuse\n     de passer sous sa largeur intrinseque et ferait deborder la rangee, que `nowrap` empeche justement\n     d'enrouler. */\n  flex: 1 1 350px;\n  min-width: 0;\n  /* Padding vertical du Button (9px) pour que la soudure soit invisible ; horizontal reduit a 10px —\n     28px de gouttiere, c'est autant de moins pour l'intitule, qui est ce qu'on cherche a faire tenir. */\n  padding: 9px 10px;\n  font-size: 14px;\n  color: #374151;\n  /* Bordure ORANGE, et non grise : cette voie est un seul objet oriente action, dont l'input est la\n     moitie gauche. Une bordure grise a gauche et un bouton orange a droite feraient deux objets.\n     Au repos, l'orange est FANE : le bouton est alors desactive (code incomplet) et le Button se fane\n     par `opacity: .5`. #fcb98a = #f97316 a 50% sur blanc — la teinte que l'opacite produit. C'est un\n     calcul, pas un choix : une autre valeur ferait dépareiller les deux moities. */\n  border: 1px solid #fcb98a;\n  border-right: none;\n  border-radius: 8px 0 0 8px;\n}\n\n/* Code complet : l'objet entier passe a l'orange plein, en meme temps que le bouton redevient actif. */\n.catalogue-choix-code--pret .catalogue-choix-code-input {\n  border-color: #f97316;\n}\n\n/* Le placeholder SEUL est reduit — pas l'input : son `font-size` pilote aussi le code saisi, qu'on\n   veut lisible a 14px. Ici c'est un intitule long dans une boite etroite, il peut se contenter de\n   moins pour tenir en entier plutot que de finir en ellipse. */\n.catalogue-choix-code-input::placeholder {\n  font-size: 12px;\n}\n\n/* La valeur, elle, est un code : meme traitement que partout ailleurs dans la feature. */\n.catalogue-choix-code-input:not(:placeholder-shown) {\n  font-family: 'Courier New', Courier, monospace;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n}\n\n/* Le focus est signale par l'ombre du GROUPE (cf. `.catalogue-choix-code:focus-within`), pas ici : la\n   bordure, elle, porte l'etat du bouton (fane/plein).\n   `border-color` est REDECLARE, pas oublie : `App.css` porte un `input:focus { border-color: #f97316 }`\n   GLOBAL. Ne pas le contredire, c'est le laisser rallumer l'orange plein au focus alors que le bouton\n   est encore fane. Ma regle pese (0,2,0) contre (0,1,1) — elle gagne des lors qu'elle declare la\n   couleur. */\n.catalogue-choix-code-input:focus {\n  outline: none;\n  border-color: #fcb98a;\n}\n\n/* Code complet + focus : l'orange plein, comme le bouton redevenu actif. (0,3,0) > (0,2,0). */\n.catalogue-choix-code--pret .catalogue-choix-code-input:focus {\n  border-color: #f97316;\n}\n\n.catalogue-choix-code-input:disabled {\n  background: #f8f9fa;\n  cursor: not-allowed;\n}\n\n/* Cote jointure : angles droits, pour que les deux ne fassent qu'un.\n   Le bouton ne grandit pas et ne s'enroule pas : son libelle est court (\"Charger\"), donc il tient sur\n   une ligne et laisse tout le reste du tiers a l'input, qui prime — c'est lui qu'on remplit. */\n.catalogue-choix-code > button {\n  /* `0 1 auto` et non `0 0 auto` : il garde la largeur de son libelle mais CEDE plutot que de deborder\n     du groupe. Un enfant qui deborde depasse la boite sur laquelle l'ombre est dessinee — elle se\n     retrouve alors derriere lui, ce qui la fait paraitre coupee a droite. */\n  flex: 0 1 auto;\n  min-width: 0;\n  border-radius: 0 8px 8px 0;\n  white-space: nowrap;\n  padding-left: 14px;\n  padding-right: 14px;\n}\n\n/* Le bouton porte le MEME ourlet orange que l'input sur ses bords exterieurs : `.button.primary` pose\n   `border: none`, ce qui laissait l'objet sans contour a droite et desalignait les deux moities d'1px\n   en hauteur (l'input, lui, a ses bordures haute et basse).\n   Selecteur double-classe VOLONTAIRE : `.button.primary` pese (0,2,0) et battrait un\n   `.catalogue-choix-code > button` a (0,1,1). Pas de `!important` — la specificite suffit.\n   `border-left: none` : c'est la soudure, l'input y pose deja la sienne. */\n.catalogue-choix-code > .button.primary {\n  border: 1px solid #f97316;\n  border-left: none;\n}\n\n.catalogue-choix-code > .button.primary:hover {\n  border-color: #ea580c;\n}\n\n\n/* Choix 2 retenu : ce message prend la place de l'apercu du catalogue. Meme emprise verticale que la\n   preview qu'il remplace, pour que la page ne saute pas quand l'acheteur change d'avis.\n\n   Rendu calque sur l'encadre du CODE dans le devis PDF (ChiffragePDF, `codeSection` : bordure 2px\n   #f97316, fond #FFF7ED, radius 8) : ce message occupe la meme place que le chiffrage a venir, il\n   doit se lire comme lui et non comme une note grise parmi d'autres.\n\n   Div AUTONOME, plus un composant Banner : ce n'est pas un message d'etat parmi d'autres mais le\n   contenu meme de la section, la ou s'affiche normalement le catalogue. Aucune dependance a\n   Banner.css — donc pas de surcharge de specificite a gagner, ni d'icone grise a neutraliser. */\n.catalogue-attente-titulaire {\n  margin-bottom: 12px;\n  border: 2px solid #f97316;\n  border-radius: 8px;\n  background: #fff7ed;\n  color: #c2410c;\n  /* Un cran au-dessus des 1.4rem courants : \"un peu plus gros\", pas un titre. */\n  font-size: 1.6rem;\n  font-weight: 500;\n  line-height: 1.5;\n  padding: 1.15rem 1.55rem;\n  text-align: center;\n}\n\n.catalogue-preview-inline {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  /* `zoom` reflow proprement, sans l'espace mort d'un transform: scale. */\n  zoom: 0.8;\n}\n\n.catalogue-preview-inline:hover,\n.catalogue-preview-inline:focus-visible {\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n  outline: none;\n}\n\n/* Le catalogue est deja encadre par le conteneur : pas de double bordure. */\n.catalogue-preview-inline .modal-articles {\n  border: none;\n}\n\n/* AUCUN element interieur ne capte le clic : il doit remonter au conteneur, qui ouvre la vraie\n   modale. On neutralise donc tout le sous-arbre (recherche, Details, controles de quantite...) plutot\n   que d'enumerer les elements un par un et d'en oublier. */\n.catalogue-preview-inline .modal-articles * {\n  pointer-events: none;\n}\n\n/* Curseur pointer sur TOUT l'apercu : il est cliquable de bout en bout (l'input de recherche\n   afficherait sinon un curseur texte, les boutons leur propre curseur). */\n.catalogue-preview-inline,\n.catalogue-preview-inline * {\n  cursor: pointer;\n}\n\n/* Titre reduit : l'apercu est une miniature, pas la modale. */\n.catalogue-preview-inline .modal-articles-header h2 {\n  font-size: 1.6rem;\n}\n\n/* Mention réglementaire du « Descriptif procédural » (BC acheteur ET prestataire) : l'espace SOUS la\n   bannière doit égaler celui AU-DESSUS.\n\n   Au-dessus = padding-top de la section. ATTENTION : ce n'est PAS le 1.5rem de SectionPliable.css,\n   surchargé dans les deux vues BC par `.consultation-bc .section-pliable-content { padding: 4rem }`\n   (spécificité 0,2,0 contre 0,1,0). En dessous = `margin-bottom` de `.ui-banner`, qui vaut 1.5rem\n   par défaut — d'où une asymétrie visible de 4rem contre 1.5rem.\n\n   Sélecteur ancré sur `.consultation-bc` : la valeur 4rem ne vaut QUE dans ce contexte, la reprendre\n   hors de lui recréerait l'écart en sens inverse. Classe dédiée pour ne toucher aucune autre bannière. */\n.consultation-bc .ui-banner.bc-mention-procedural {\n  margin-bottom: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
